import React, { PureComponent } from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import ReactTooltip from 'react-tooltip';

import { CellText } from './tableStyles';

export default class NoteBlock extends PureComponent {
  constructor() {
    super();
    this.state = {
      croppedText: null,
      isClamped: false
    };
    this.renderContent = this.renderContent.bind(this);
  }

  renderContent() {
    const { croppedText, isClamped } = this.state;
    const note = this.props && this.props.note || '';
    if (!croppedText) {
      // first cutting and init
      return (
        <LinesEllipsis
          text={note}
          maxLine="2"
          ellipsis="..."
          basedOn="words"
          onReflow={({ clamped, text }) => {
            this.setState({ isClamped: clamped, croppedText: text });
          }}
        />
      );
    } else {
      // after cropping text
      if (isClamped) {
        return (
          <div>
            <CellText data-tip={note} data-for="note-tooltip">
              {croppedText} ...
            </CellText>
            <ReactTooltip
              effect="solid"
              border={true}
              delayShow={500}
              id="note-tooltip"
              type="light"
            />
          </div>
        );
      } else {
        return <CellText>{croppedText}</CellText>;
      }
    }
  }

  render() {
    return this.renderContent();
  }
}
